export default __webpack_public_path__ + "static/media/exterior1.9ab181f7.jpg";